import { Link2 } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { createPortal } from "react-dom";
import QuickEstimateLink from "./QuickEstimateLink";

/**
 * Legacy name, new behavior.
 *
 * The primary tab bar used to live here as a `position: fixed` bottom
 * dock. iOS Safari kept detaching that layer to a transformed ancestor
 * and dropping the whole bar mid-page. We moved the tabs into
 * Header.js (second row of the already-stable sticky top header), so
 * this component now only owns the floating "Send Estimate Link" FAB
 * that appears on the Estimates tab.
 *
 * All 20+ pages still `import BottomNav` and render `<BottomNav />` —
 * keeping the file keeps those imports valid without touching every
 * page. Rendering is portaled to `document.body` because the FAB is a
 * single small element and `position: fixed` works fine for it.
 */
export default function BottomNav() {
  const location = useLocation();
  const [quickEstimateOpen, setQuickEstimateOpen] = useState(false);

  const onEstimatesTab =
    location.pathname === "/estimates" ||
    location.pathname.startsWith("/estimates/");

  if (!onEstimatesTab) return null;

  return createPortal(
    <>
      <button
        onClick={() => setQuickEstimateOpen(true)}
        className="fixed right-4 h-12 w-12 rounded-full bg-[#207024] hover:bg-[#1a5c1d] text-white shadow-lg flex items-center justify-center z-[60]"
        style={{
          bottom: "calc(env(safe-area-inset-bottom) + 1.25rem)",
        }}
        title="Send Estimate Link"
        data-testid="quick-estimate-fab"
      >
        <Link2 className="w-5 h-5" />
      </button>

      <QuickEstimateLink open={quickEstimateOpen} onOpenChange={setQuickEstimateOpen} />
    </>,
    document.body
  );
}
